module.exports = __webpack_public_path__ + "static/media/lang10.db05ac19.mp3";